import React from 'react';
import { User } from 'lucide-react';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '../ui/dialog';
import { ContactFormFields } from './ContactFormFields';

export const AddContactDialog = ({
  open,
  onOpenChange,
  contactData,
  onContactDataChange,
  onSave,
  saving
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <User className="w-5 h-5" />
            Add New Contact
          </DialogTitle>
          <DialogDescription>
            Manually add a contact to your list. Only email is required.
          </DialogDescription>
        </DialogHeader>
        
        <ContactFormFields 
          data={contactData} 
          onChange={onContactDataChange}
          prefix=""
        />
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={onSave}
            disabled={saving || !contactData.email}
            className="bg-slate-900 hover:bg-slate-800"
            data-testid="save-contact-btn"
          >
            {saving ? (
              <span className="flex items-center gap-2">
                <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                Saving...
              </span>
            ) : (
              "Add Contact"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddContactDialog;
